import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=2735709b&scoped=true&"
import script from "./informationDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./informationDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./informationDetail.vue?vue&type=style&index=0&id=2735709b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735709b",
  null
  
)

export default component.exports